export default __webpack_public_path__ + "static/media/SAP_2011_logo.6a163905.svg";